import NemligLogo from "../../assets/logos/nemlig-logo.png";
import ArjoLogo from "../../assets/logos/arjo.png";
import CbsLogo from "../../assets/logos/cbs.jpg";
import DjoefLogo from "../../assets/logos/djoef.png";
import DsrLogo from "../../assets/logos/dsr.png";
import EgmontLogo from "../../assets/logos/egmont.jpg";
import FolkekirkenLogo from "../../assets/logos/folkekirken.png";
import GetineLogo from "../../assets/logos/getinge.png";
import MaquetLogo from "../../assets/logos/maquet.JPG";
import PolitiLogo from "../../assets/logos/politi.png";
import RegHLogo from "../../assets/logos/regH.jpg";
import RossOffshoreLogo from "../../assets/logos/rossOffshore.png";
import SampensionLogo from "../../assets/logos/sampension.jpg";
import TiponiLogo from "../../assets/logos/tiponi.png";
import Type2DialogLogo from "../../assets/logos/type2dialog.png";
import UrLogo from "../../assets/logos/ur.png";

const logos = [
  {
    id: 1,
    logo: NemligLogo
  },
  {
    id: 2,
    logo: ArjoLogo
  },
  {
    id: 3,
    logo: CbsLogo
  },
  {
    id: 4,
    logo: DjoefLogo
  },
  {
    id: 5,
    logo: DsrLogo
  },
  {
    id: 6,
    logo: EgmontLogo
  },
  {
    id: 7,
    logo: FolkekirkenLogo
  },
  {
    id: 8,
    logo: GetineLogo
  },

  {
    id: 9,
    logo: MaquetLogo
  },
  {
    id: 10,
    logo: PolitiLogo
  },
  { id: 11, logo: RegHLogo },
  { id: 12, logo: RossOffshoreLogo },
  {
    id: 12,
    logo: SampensionLogo
  },
  {
    id: 13,
    logo: TiponiLogo
  },
  {
    id: 13,
    logo: Type2DialogLogo
  },
  {
    id: 14,
    logo: UrLogo
  }
];

export default logos;



// WEBPACK FOOTER //
// ./src/components/LogoCarousel/logos.js